module.exports = __webpack_public_path__ + "static/media/ibd_hips1.80a7f953.png";